import styled from 'styled-components';
import theme from 'styles/theme';

export const LockAssignmentSwitchContainerStyled = styled.div`
  form {
    width: 100%;

    div {
      padding: 0;
    }
  }

  select.no-lock-option-selected {
    color: ${theme.colors.gray500};
  }
`;
